import { PaymentMethod } from '../types';
import { getPaymentMethodLogoUrl } from '../utils';
import { Value } from './OrderDetails';

export const CreditCardPaymentMethod = ({
  paymentMethod
}: {
  paymentMethod: PaymentMethod;
}) => {
  const lastFourDigits = paymentMethod?.metadata?.cardLastFourDigits;

  if (paymentMethod.primaryMethod !== 'Credit Card') {
    return (
      <div
        className="flex items-center gap-4 min-w-0"
        data-testid="orderDetailsPaymentMethod"
      >
        <img
          src={getPaymentMethodLogoUrl(paymentMethod.primaryMethod || '')}
          alt={paymentMethod.primaryMethod || ''}
          data-testid="cardSchemeIcon"
          onError={(e) => {
            e.currentTarget.style.display = 'none';
          }}
        />
        <Value value={paymentMethod.primaryMethod} />
      </div>
    );
  }

  return (
    <div
      className="flex items-center gap-4 min-w-0"
      data-testid="orderDetailsPaymentMethod"
    >
      <img
        src={getPaymentMethodLogoUrl(paymentMethod.secondaryMethod || '')}
        alt={paymentMethod.secondaryMethod || ''}
        data-testid="cardSchemeIcon"
        onError={(e) => {
          e.currentTarget.style.display = 'none';
        }}
      />
      <span className="text-sm text-base-mutedForeground font-light">
        **** {lastFourDigits}
      </span>
    </div>
  );
};
